export const STEP_KEYS = ["formulaire", "interview", "recit", "bd", "minisite"];

export const STATES = {
  formulaire: ["lien_envoye", "lien_expire", "recu", "sans_formulaire"],
  interview: ["a_deposer", "deposee"],
  recit: [
    "a_lancer",
    "extraction",
    "histoires_a_choisir",
    "redaction",
    "redige",
    "erreur",
  ],
  bd: ["non_demarree", "en_cours", "complete"],
  minisite: ["non_demarre", "brouillon", "perime", "publie"],
};

export const DONE_STATES = {
  formulaire: ["recu", "sans_formulaire"],
  interview: ["deposee"],
  recit: ["redige"],
  bd: ["complete"],
  minisite: ["publie", "perime"],
};

export const CURRENT_DONE = "termine";

export const STEP_LABELS = {
  formulaire: "Formulaire",
  interview: "Interview",
  recit: "Récit",
  bd: "BD",
  minisite: "Mini-site",
};

export const STATE_LABELS = {
  lien_envoye: "lien envoyé",
  lien_expire: "lien expiré",
  recu: "reçu",
  sans_formulaire: "sans formulaire",
  a_deposer: "à déposer",
  deposee: "déposée",
  a_lancer: "à lancer",
  extraction: "extraction",
  histoires_a_choisir: "histoires à choisir",
  redaction: "rédaction",
  redige: "rédigé",
  erreur: "erreur",
  non_demarree: "non démarrée",
  en_cours: (step) => `${step.validated}/${step.expected} validées`,
  complete: "terminée",
  non_demarre: "non démarré",
  brouillon: "brouillon",
  perime: "périmé",
  publie: "publié",
};

export function isDone(key, state) {
  return DONE_STATES[key]?.includes(state) || false;
}

export function stepTone(key, step, current) {
  if (!step) return "todo";
  if (key === "recit" && step.state === "erreur") return "error";
  if (isDone(key, step.state)) return "done";
  if (current === key) return "current";
  return "todo";
}

export function stateLabel(key, step) {
  if (!step) return "avancement indisponible";
  const label = STATE_LABELS[step.state];
  if (typeof label === "function") return label(step);
  return label || "avancement indisponible";
}

export function progressLabel(steps) {
  const hasCompleteSteps = Boolean(
    steps
      && STEP_KEYS.every((key) => steps[key]?.state)
      && (STEP_KEYS.includes(steps.current) || steps.current === CURRENT_DONE)
  );
  if (!hasCompleteSteps) return "avancement indisponible";
  if (steps.current === CURRENT_DONE) return "Terminé";
  return `${STEP_LABELS[steps.current]} · ${stateLabel(
    steps.current,
    steps[steps.current]
  )}`;
}
